import React from "react";
import styles from "./Loading.module.css";

const Loading = ({ children }) => {
  return (
    <div className="container">
      <div className={styles.containerLoading}>
        <h1 className={styles.textLoading}>{children}</h1>
      </div>
    </div>
  );
};

export default Loading;
